import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from '../../../../services/common/user.service';
import { RestService } from '../../../../services/common/rest.service';
import { CommonService } from '../../../../services/common';
import { ToasterMessage } from '../../../../../appconfig';
import { CustomerAddUpdateTab } from './cutomer-addupdate.model';
import { ToasterService } from '../../../../services/common/toaster.service';

@Component({
  selector: 'app-client-addupdate',
  templateUrl: './client-addupdate.component.html',
  styleUrl: './client-addupdate.component.scss'
})
export class ClientAddupdateComponent {
  @Input() currentCustomer: any;
  @Input() context: any;
  @Input() userData: any;
  @Output() changeModelStatus = new EventEmitter<any>();
  @Output() edituserPanel = new EventEmitter<any>();

  customerForm!: FormGroup
  bankData: any;
  params: any;
  bankList: any = [];
  selectedBankId: any;
  currentCustomersData: any;
  selectedTab!: CustomerAddUpdateTab;

  constructor(private api: RestService, private toasterService: ToasterService, public commonService: CommonService, private fb: FormBuilder, public userService: UserService) {
    //getting the bank account details

  }

  ngOnInit() {
    this.currentCustomersData = this.currentCustomer;
    this.selectedTab = CustomerAddUpdateTab.nameAndContact;
    this.initiateCustomerForm();
    // this.setCustomerData();
    // this.getBankDetails();

  }

  /**
 * Customer Form Controls Key
 */
  initiateCustomerForm() {
    this.customerForm = this.fb.group({
      id: [0],
      name: [this.currentCustomersData?.firstName + this.currentCustomersData?.lastName],
      fatherName: [this.currentCustomersData?.fatherHusbandName],
      contactNo: [this.currentCustomersData?.primaryPhoneNo],
      email: [this.currentCustomersData?.email],
      address: [this.currentCustomersData?.address],
      permanentAddress: [this.currentCustomersData?.permanentAddress],
      adharcardNo: [this.currentCustomersData?.adharcardNo],
      pancardNo: [this.currentCustomersData?.panCardNo],
      religion: [this.currentCustomersData?.religion],
      community: [this.currentCustomersData?.community],
      ifsc: [this.currentCustomersData?.ifsc],
      bankAccountNo: [this.currentCustomersData?.bankAccountNo],
      accountHolderName: [this.currentCustomersData?.accountHolderName],
      branchAddress: [this.currentCustomersData?.branchAddress],
      branchName: [this.currentCustomersData?.branchName],
      userId: this.currentCustomersData?.id
    })
  }

  /**
   * set customer data if current selected data is available
   */
  setCustomerData() {
    if (this.currentCustomersData) {
      this.customerForm.patchValue({
        name: this.currentCustomersData.name,
        fatherName: this.currentCustomersData.fatherName,
        contactNo: this.currentCustomersData.contactNo,
        email: this.currentCustomersData.email,
        address: this.currentCustomersData.address,
        permanentAddress: this.currentCustomersData.permanentAddress,
        adharcardNo: this.currentCustomersData.adharcardNo,
        pancardNo: this.currentCustomersData.pancardNo,
        religion: this.currentCustomersData.religion,
        community: this.currentCustomersData.community,
        ifsc: this.currentCustomersData.ifsc,
        bankAccountNo: this.currentCustomersData.bankAccountNo,
        accountHolderName: this.currentCustomersData.accountHolderName,
        branchAddress: this.currentCustomersData.branchAddress,
        branchName: this.currentCustomersData.branchName,
        userId: 1014
      });
    }
  }

  /**
   * get bank details
   */
  getBankDetails() {
    this.api.getData('bank-master').subscribe((res: any) => {
      this.bankList = res.result;
    })
  }

  /**
   * get bank if by bank name
   * @param name bank name of which id we want to be filtered
   */
  getBankIdByBankName(name: any) {
    this.selectedBankId = this.bankList.find((b: any) => b.bankName.toLowerCase() == name.toLowerCase()).id;
  }


  /**
   * on submit the bank form
   */
  onSubmit() {
    var data = {
      "userId": this.commonService.getValueFromLocalStorage("userId"),
      "bankId": this.selectedBankId,
      "ifsc": this.customerForm.value.ifsc,
      "branchName": this.customerForm.value.branchName,
      "branchAddress": this.customerForm.value.branchAddress,
      "bankAccountNo": this.customerForm.value.ifsc,
      "accountHolderName": this.customerForm.value.ifsc,
      "isPrimary": true,
      "isActive": true
    }
    this.userService.postBankData(data).subscribe((res: any) => {
      this.toasterService.showSuccess('Bank Account' + ' ' + ToasterMessage.successMessage);
      this.bankData = res;
      this.customerForm.reset();
    })
  }

  /**
   * while click on tab
   * @param tab
   */
  onTabClick(tab: string) {
    //@ts-ignore
    this.selectedTab = CustomerAddUpdateTab[CustomerAddUpdateTab[tab]];
  }

  /**
   * Handle updated customer data from bank account component
   * Keep modal open, just update local references
   * The bank account component has already updated the source customerData object
   * @param updatedCustomerData updated customer data with bank accounts
   */
  onCustomerDataUpdated(updatedCustomerData: any) {
    // Update the local reference - keep modal open
    this.currentCustomersData = updatedCustomerData;
    this.currentCustomer = updatedCustomerData;

    // Don't emit changeModelStatus here - it would close the modal
    // The data is already updated in the source object by bank-account component
    // Modal stays open on the bank tab as expected
  }

  /**
     * Click Close Model Form
     */
  Close() {
    this.edituserPanel.emit({
      "showEditprofilePanel": false
    });
  }

  /**
     * Click Close Model Form
     */
  closeBankDialogue() {
    this.userService.isCustomerData = false;
  }

  /**
   * fetch the bank detials using ifsc code
   */
  fetchBankDetails() {
    this.api.getBankDetailsByifsc(this.customerForm.value.ifsc).subscribe((res: any) => {
      this.customerForm.patchValue({
        branchAddress: res.ADDRESS,
        branchName: res.BRANCH
      });
      this.getBankIdByBankName(res.BANK);
    })
  }
}
